import { routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const apbRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.apb,
    name: routeNames.apb,
    redirect: { name: routeNames.apbPractices },
    meta: {
      labelKey: 'apb',
    },
  },
  {
    path: routePaths.apbPractices,
    name: routeNames.apbPractices,
    component: () => import('@/pages/apb/ApbPracticesView.vue'),
    meta: {
      permission: 'apb.read.all',
      icon: 'material-symbols-outlined',
      iconText: 'contacts',
      labelKey: 'apbPractices',
      featureFlag: 'apb',
    },
  },
  {
    path: routePaths.apbProcessedEmails,
    name: routeNames.apbProcessedEmails,
    component: () => import('@/pages/apb/ApbProcessedEmailsView.vue'),
    meta: {
      permission: 'apb.read.all',
      icon: 'material-symbols-outlined',
      iconText: 'forward_to_inbox',
      labelKey: 'apbProcessedEmails',
      featureFlag: 'apb',
    },
  },
  {
    path: routePaths.apbProcessedEmailDetails,
    name: routeNames.apbProcessedEmailDetails,
    component: () => import('@/pages/apb/ApbProcessedEmailDetailsView.vue'),
    meta: {
      permission: 'apb.read.all',
      featureFlag: 'apb',
    },
  },
]
